export const ENTITY_ANNOTATION_EXTENSION_TYPE = 'com.rovo.entity-annotation';
export const INFERRED_PROJECT_EXTENSION_KEY = 'inferred-project';
export const ENTITY_ANNOTATION_PERSON_LOCAL_ID_PREFIX = 'rovo-entity-annotation-person:';

const ENTITY_ANNOTATION_TYPES = ['Person', 'InferredProject'] as const;

export type EntityAnnotationType = (typeof ENTITY_ANNOTATION_TYPES)[number];

export type EntityAnnotationEntity = {
	type: EntityAnnotationType;
	mention: string;
	start: number;
	end: number;
	ari: string;
	canonicalName: string;
	confidenceScore: number;
};

export type EntityAnnotationBatch = {
	sentence: string;
	entities: readonly EntityAnnotationEntity[];
};

const entityAnnotationTypeSet = new Set<string>(ENTITY_ANNOTATION_TYPES);

const isRecord = (value: unknown): value is Record<string, unknown> =>
	typeof value === 'object' && value !== null;

export const isEntityAnnotationEntity = (value: unknown): value is EntityAnnotationEntity =>
	isRecord(value) &&
	typeof value.type === 'string' &&
	entityAnnotationTypeSet.has(value.type) &&
	typeof value.mention === 'string' &&
	typeof value.start === 'number' &&
	Number.isFinite(value.start) &&
	typeof value.end === 'number' &&
	Number.isFinite(value.end) &&
	typeof value.ari === 'string' &&
	typeof value.canonicalName === 'string' &&
	typeof value.confidenceScore === 'number' &&
	Number.isFinite(value.confidenceScore);
